export const home = {
  // ─── Greeting and Hero Headline ─────────
  'home.greeting.signedOut': 'Welcome.',
  'home.greeting.new': 'Welcome, {customerName}.',
  'home.greeting.morning': 'Morning, {customerName}.',
  'home.greeting.afternoon': 'Ready for lunch, {customerName}?',
  'home.greeting.evening': 'Got dinner plans, {customerName}?',
  'home.greeting.specialDay': 'Happy Holidays, {customerName}!',

  'home.navigation': 'open home page',
  'test.plural': `You have {numVegetables, plural,
    =0 {no vegetables.}
    =1 {1 vegetable.}
    other {# vegetables.}
  }`,
  'sidebar.header.heading': `Let's get cooking`,
  'sidebar.header.heading-with-variable': `Let's get {var}`,
  'sidebar.header.heading-with-multiple-variables': `{var1} get {var2}`,
  'sidebar.header.sub-heading': `How would you like your sweetgreen today?`,
  'sidebar.header.login-or-sign-up': 'Login / Join',
  'sidebar.search.pickup-or-outpost': 'PICKUP + OUTPOST',
  'sidebar.search.search-option.delivery': 'DELIVERY',
  'sidebar.search.search-option.placeholder':
    'Search store, city, state, or zip',
  'home.scan-to-pay': 'Scan to pay',
  'home.scan-to-pay-disabled': 'Scan to pay - coming soon',
  'home.scan-to-pay.pass-failure': 'The sweetgreen pass could not be loaded.',
  'home.scan-to-pay.pass-existing':
    'The sweetgreen pass is already in your wallet.',

  // ─── HERO ───────────────────────────────────────────────────────────────────────

  'home.hero-cta': 'Explore Menu',

  // ─── REORDER RAIL ───────────────────────────────────────────────────────────────

  'home.reorder-rail-title': 'Order again',
  'home.reorder-rail-all-orders': 'All Orders',
  'home.reorder-rail-empty-text':
    'Once you place an order your recent orders will appear here',
  'home.reorder-rail-error-text':
    'We ran into an issue. Please try again later.',

  // ─── Dynamic Cards ───
  'home.dynamic-cta.bag.a11y-hint': 'Opens your bag',
  'home.dynamic-cta.active-order.title': 'Preparing - ETA {eta}',
  'home.dynamic-cta.active-order.subtitle': '{orderType} from {restaurant}',
  'home.dynamic-cta.active-order.a11y-hint': 'Opens your active order details',
  'home.dynamic-cta.rate-order.title': 'Let us know how we did',
  'home.dynamic-cta.rate-order.subtitle': 'Rate your last order - {summary}',
  'home.dynamic-cta.rate-order.a11y-hint': 'Opens your customer voice form',

  // ─── Featured Channels Cards (to be deprecated) ───
  'home.featured-channels.at-messaging': 'at {location}',
  'home.featured-channels.default-pickup': 'Find your local store',
  'home.featured-channels.default-delivery': 'Straight to your home',
  'home.featured-channels.default-secondary-title-pickup':
    'Start a pickup order at your local sweetgreen',
  'home.featured-channels.default-secondary-title-outpost':
    'Get your sweetgreen delivered straight to your community each day. ',
  'home.featured-channels.default-secondary-text-outpost': 'Try outpost.',
  'home.featured-channels.secondary-title':
    'Start {orderType} order at {location}',
  'home.featured-channels.to-messaging': 'to {location}',
  'home.featured-channels.a11y-label': 'Start {orderType} order at {location}',
  'home.featured-channels.a11y-delivery-label': 'Start delivery order',

  // ─── Featured Channels Cards ───
  'featured-channel.evergreen.title': 'Search for pickup, delivery and Outpost',
  'featured-channel.evergreen.button': 'Order now',
  'featured-channel.primary.label': 'Recent Location',
  'featured-channel.primary.button': `{orderType, select,
    pickup {Order pickup}
    outpost {Order Outpost}
    delivery {Order delivery}
    other {}
  }`,
  'featured-channel.secondary.title': 'Search for pickup, delivery and Outpost',
  'featured-channel.secondary.button-large': 'See more locations',
  'featured-channel.secondary.button-medium': 'Search',
};
